
export function toInt(vv){
  var v=Math.abs(vv)
  v=(v>(parseInt(v)+0.5))?parseInt(v+1):parseInt(v)
  return (vv>=0)?v:-v
}

export function generateRandomString(length) {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }
  
  return result;
}

export const PLAY_OPTION = { 
  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
  autoplay: true, //如果true,浏览器准备好时开始回放。
  muted: false, // 默认情况下将会消除任何音频。
  loop: false, // 导致视频一结束就重新开始。
  preload: 'auto',
  language: 'zh-CN',
  //aspectRatio: '3:4',
  fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
  sources: [], 
  //poster: require("../assets/cover_video.jpg"), //你的封面地址
  //width: document.documentElement.clientWidth, //播放器宽度
  notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
  flash: { hls: { withCredentials: false } },
  html5: { hls: { withCredentials: false } },
  controls: true,
  controlBar: {
    timeDivider: true,
    volumePanel: false,
    durationDisplay: true,
    remainingTimeDisplay: false,
    fullscreenToggle: true  //全屏按钮
  }   
}

export const prompt_example =`
你是视频脚本制作者，请根据后面的剧情梗概部分，创作一个完整的视频脚本，需要包含文生图提示词和剧情文案。
具体要求如下：
1，5个场景，是一个完整的故事，剧情丰富
2，每个场景需要包含丰富的剧情文案和文生图提示词
3，每个场景的文生图提示词用英语生成，图片需要是卡通风格
4，每个场景的文案文本用中文生成，每个场景的文案文字数量大概在20到50字
剧情梗概如下：
王子爱上了平民，但是平民家里很贫穷，国王反对这门婚事，王子决定带着平民私奔，私奔的夜晚，突然天降暴雨，河水暴涨，拼命不行被水冲走，王子难过极了。

请用json格式输出结果，不要添加任何其他内容，格式例子如下：
{
  content_list:[{
    "num":1,
    "text2image_prompt": "场景1的文生图提示词，用英文生成”,
    "text2voice_prompt": "场景1的文案文本，用中文生成，20到50个文字"
    },{
    "num":2,
    "text2image_prompt": "场景2的文生图提示词，用英文生成",
    "text2voice_prompt": "场景2的文案文本，用中文生成，20到50个文字"
    },{
    "num":3,
    "text2image_prompt": "场景3的文生图提示词，用英文生成",
    "text2voice_prompt": "场景3的文案文本，用中文生成，20到50个文字"
  }]
}
请注意，以上仅仅是例子，场景数量可能不对，请按照要求来生成，现在请帮我创作
`